import React, { useLayoutEffect, useRef } from 'react';
import '../styles/OutageBanner.css';

const OutageBanner: React.FC = () => {
  const bannerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const banner = bannerRef.current;
    if (!banner) return;

    const updateHeight = () => {
      document.documentElement.style.setProperty(
        '--outage-banner-height',
        `${banner.getBoundingClientRect().height}px`
      );
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(banner);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty('--outage-banner-height');
    };
  }, []);

  return (
    <div ref={bannerRef} className="outage-banner" role="alert">
      Quizzify is down right now due to an issue with our backend provider. We are working on it!
    </div>
  );
};

export default OutageBanner;
